import {createWebHistory, createRouter} from "vue-router";
import DashboardPage from '@/components/dashboard/DashboardPage.vue'
import AssemblePage from "@/components/assemble/AssemblePage.vue";
import AssembleOrderPage from "@/components/assemble/AssembleOrderPage.vue";
import SlotLocatorPage from "@/components/piecingup/SlotLocatorPage.vue";
import AssembleTowelPage from "@/components/assemble/AssembleTowelPage.vue";
import CustomerColoursPage from "@/components/customer/CustomerColoursPage.vue";
import CustomerAnalyticsPage from "@/components/customer/CustomerAnalyticsPage.vue";
import CustomersListPage from "@/components/customer/CustomersListPage.vue";
import SigninEpos from "@/components/auth/SigninEpos.vue";
import AutologinPage from "@/components/auth/AutologinPage.vue";
import GarmentTypePage from "@/components/garmenttypes/GarmentTypePage.vue";
import GarmentTypeListPage from "@/components/garmenttypes/GarmentTypeListPage.vue";
import GarmentTypeCreatePage from "@/components/garmenttypes/GarmentTypeCreatePage.vue";
import VouchersPage from "@/components/vouchers/VouchersPage.vue";
import TestPage from "@/components/TestPage.vue";
import BrandListPage from "@/components/brand/BrandListPage.vue";
import DriverPerformancePage from "@/components/logs/DriverPerformancePage.vue";
import ShoeRepairPage from "@/components/logs/ShoeRepairPage.vue";
import LogisticsPage from "@/components/logs/LogisticsPage.vue";
import ServicePriceLogsPage from "@/components/logs/ServicePriceLogsPage.vue";
import RedirectPage from "@/components/common/RedirectPage.vue";
import OrdersWaitPage from "@/components/order/OrdersWaitPage.vue";
import OrdersPartialsPage from "@/components/order/OrdersPartialsPage.vue";
import OrdersCreditPage from "@/components/order/OrdersCreditPage.vue";
import OrderTimelinePage from "@/components/order/OrderTimelinePage.vue";
import LockerUsagePage  from "@/components/reports/LockerUsagePage.vue";
import RfidDashboardPage from "@/components/rfid/RfidDashboardPage.vue";
import RfidAssociateTagPage from "@/components/rfid/RfidAssociateTagPage.vue";
import RfidAssociationListLogsPage from "@/components/rfid/RfidAssociationListLogsPage.vue";
import RfidAssociationLogsPage from "@/components/rfid/RfidAssociationLogsPage.vue";
import RfidProcessingSelectionPage from "@/components/rfid/RfidProcessingSelectionPage.vue";
import RfidProcessingOrderPage from "./components/rfid/RfidProcessingOrderPage.vue";
import RfidProcessingListLogsPage from "./components/rfid/RfidProcessingListLogsPage.vue";
import RfidProcessingLogsPage from "./components/rfid/RfidProcessingLogsPage.vue";
import RfidRogueListLogsPage from "./components/rfid/RfidRogueListLogsPage.vue";
import RfidRogueLogsPage from "./components/rfid/RfidRogueLogsPage.vue";
import RfidFoldingTicketPage  from "./components/rfid/RfidFoldingTicketPage.vue";
import RfidFoldingTicketOrderPage  from "./components/rfid/RfidFoldingTicketOrderPage.vue";
import RfidPieceupPage from "./components/rfid/RfidPieceupPage.vue";
import RfidPieceupLogsPage from "./components/rfid/RfidPieceupLogsPage.vue";
import QpupPage from "./components/qpup/QpupPage.vue";
import B2BSchedulePage from "@/components/b2b/B2BSchedulePage.vue";
import B2BScheduleAdminPage from "@/components/b2b/B2BScheduleAdminPage.vue";



import store  from './store/index.js'
import VueCookies from "vue-cookies";
import sessionService from "@/services/SessionService";
import {
  getContextBaseUrl,
  getSessionExpiredRedirectBase,
  persistLastContextPath,
} from '@/utils/contextRedirect'

const redirectRoute = (path, resolveLocation, options = {}) => ({
  path,
  component: RedirectPage,
  meta: {
    hideShell: true,
    ...(options.meta || {}),
  },
  beforeEnter(to, from) {
    const redirectLocation = typeof resolveLocation === 'function'
      ? resolveLocation(to, from)
      : resolveLocation

    window.location.replace(redirectLocation)

    return false
  },
  ...options,
})


const routes = [
  {
    path: '/',
    component: DashboardPage,
    beforeEnter (to, from, next) {
      if (store.getters.token) {
        next()
      } else {
        next('/signin')
      }
    }
  },
  {
    path: "/autologin",
    component: AutologinPage,
    beforeEnter(to, from, next) {

      let sessionUser = {}
      sessionService.getSessionDetails()
          .then(response => {
            sessionUser.id = response.data.data.user.userid;
            sessionUser.username = response.data.data.user.username;
            sessionUser.userlabel = response.data.data.user.userlabel;
            sessionUser.workstation = response.data.data.workstation.name;
            localStorage.setItem("sessionDetails", JSON.stringify(sessionUser))
          })
          .catch(e => {
            console.log(e);
          });

      if (typeof to.query.tk != "undefined") {
        let idToken = to.query.tk;
        let userWorkstation = to.query.uw;
        let userId = to.query.uid;
        let target = to.query.target;

        VueCookies.set('epos2_token',idToken);
        VueCookies.set('epos2_userid',userId);
        VueCookies.set('epos2_workstationid',userWorkstation);

        store.commit('authUser', {
          token: idToken,
          userId: userId,
          userWorkstation: userWorkstation,
        });

        next(target)
      }
      else {
        next('/signin')
      }
    },
  },
  redirectRoute('/signin', (to, from) => getSessionExpiredRedirectBase(from?.path, to?.redirectedFrom?.path), {
    component: SigninEpos,
  }),
  redirectRoute('/logout', (to, from) => {
    const baseUrl = getContextBaseUrl(from?.path)

    return baseUrl + "/index.php?page=session&mode=logout"
  }),

  redirectRoute('/dashboard', () => process.env.VUE_APP_EPOS_API_BASE, {
    beforeEnter(to, from, next) {
      if (store.getters.token) {
        window.location.replace(process.env.VUE_APP_EPOS_API_BASE)

        return false
      }

      next('/signin')
    }
  }),
    /*
  {
    path: '/customers',
    component: DashboardPage,
    beforeEnter (to, from, next) {
      window.location.href = process.env.VUE_APP_EPOS_API_BASE + '/index.php?page=customer&mode=list';
    }
  },

     */
  redirectRoute('/customers/:id', (to) => process.env.VUE_APP_EPOS_API_BASE + '?page=customer&mode=edit&customer_id=' + to.params.id, {
    name: 'ViewCustomer',
  }),
  {
    path: '/customers/analytics',
    component: CustomerAnalyticsPage,
    beforeEnter (to, from, next) {
      if (store.getters.token) {
        next()
      } else {
        next('/signin')
      }
    }
  },
  {
    path: '/customers',
    component: CustomersListPage,
    beforeEnter (to, from, next) {
      if (store.getters.token) {
        next()
      } else {
        next('/signin')
      }
    }
  },
  {
    path: '/logs/driver-performance',
    component: DriverPerformancePage,
    beforeEnter (to, from, next) {
      if (store.getters.token) {
        next()
      } else {
        next('/signin')
      }
    }
  },
  {
    path: '/logs/shoe-repair',
    component: ShoeRepairPage,
    beforeEnter (to, from, next) {
      if (store.getters.token) {
        next()
      } else {
        next('/signin')
      }
    }
  },
  {
    path: '/logs/logistics',
    component: LogisticsPage,
    beforeEnter (to, from, next) {
      if (store.getters.token) {
        next()
      } else {
        next('/signin')
      }
    }
  },
  {
    path: '/logs/service-prices/:garmenttypeId?',
    component: ServicePriceLogsPage,
    name: 'ServicePriceLogs',
    beforeEnter (to, from, next) {
      if (store.getters.token) {
        next()
      } else {
        next('/signin')
      }
    }
  },
  redirectRoute('/orders/:id', (to) => process.env.VUE_APP_EPOS_API_BASE + '?page=order&mode=process&order_id=' + to.params.id, {
    name: 'ViewOrder',
  }),
  {
    path: '/orders/:id/timeline',
    name: 'OrderTimeline',
    component: OrderTimelinePage,
    beforeEnter (to, from, next) {
      if (store.getters.token) {
        next()
      } else {
        next('/signin')
      }
    }
  },
  redirectRoute('/process', () => process.env.VUE_APP_EPOS_API_BASE + '/index.php?page=order&mode=processlist'),
  redirectRoute('/orders/all', () => process.env.VUE_APP_EPOS_API_BASE + '/order/list'),
  redirectRoute('/orders/live', () => process.env.VUE_APP_EPOS_API_BASE + '/index.php?page=order&mode=livelist'),
  {
    path: '/orders/wait',
    component: OrdersWaitPage,
    beforeEnter (to, from, next) {
      if (store.getters.token) {
        next()
      } else {
        next('/signin')
      }
    }
  },
  {
    path: '/orders/partials',
    component: OrdersPartialsPage,
    beforeEnter (to, from, next) {
      if (store.getters.token) {
        next()
      } else {
        next('/signin')
      }
    }
  },
  {
    path: '/orders/credit',
    component: OrdersCreditPage,
    beforeEnter (to, from, next) {
      if (store.getters.token) {
        next()
      } else {
        next('/signin')
      }
    }
  },
  redirectRoute('/orders/:id', (to) => process.env.VUE_APP_EPOS_API_BASE
      + '/order/index.php?page=order&mode=process&order_id=' + to.params.id),
  redirectRoute('/logistics', () => process.env.VUE_APP_EPOS_API_BASE + '/index.php?page=logistics&mode=manifests'),
  {
    path: '/brand',
    component: BrandListPage,
    beforeEnter (to, from, next) {
      console.log('brand auth: ' + store.getters.token);
      if (store.getters.token) {
        next()
      } else {
        next('/signin')
      }
    }
  },
  redirectRoute('/assemble-orders', () => process.env.VUE_APP_EPOS_API_BASE + '/assemble/orders'),
  {
    path: '/assemble',
    component: AssemblePage,
    beforeEnter (to, from, next) {
      //console.log('assemble auth: ' + store.getters.token);
     // console.log(to.query.token);
      if (store.getters.token) {
        next()
      } else {
        next('/signin')
      }
    }
  },
  {
    path: '/assemble-order',
    component: AssembleOrderPage,
    beforeEnter (to, from, next) {
      //console.log('assemble auth: ' + store.getters.token);
      // console.log(to.query.token);
      if (store.getters.token) {
        next()
      } else {
        next('/signin')
      }
    }
  },
  {
    path: '/assemble-towel',
    component: AssembleTowelPage,
    beforeEnter (to, from, next) {
      //console.log('assemble auth: ' + store.getters.token);
      // console.log(to.query.token);
      if (store.getters.token) {
        next()
      } else {
        next('/signin')
      }
    }
  },
  {
    path: '/customer-colours',
    component: CustomerColoursPage,
    beforeEnter (to, from, next) {
      console.log('customer-colours auth: ' + store.getters.token);
      if (store.getters.token) {
        next()
      } else {
        next('/signin')
      }
    }
  },
  {
    path: '/b2b-schedule',
    component: B2BSchedulePage,
    beforeEnter (to, from, next) {
      if (store.getters.token) {
        next()
      } else {
        next('/signin')
      }
    }
  },
  {
    path: '/b2b-schedule/admin',
    component: B2BScheduleAdminPage,
    beforeEnter (to, from, next) {
      if (store.getters.token) {
        next()
      } else {
        next('/signin')
      }
    }
  },
  {
    path: '/garmenttype',
    component: GarmentTypeListPage,
    beforeEnter (to, from, next) {
      if (store.getters.token) {
        next()
      } else {
        next('/signin')
      }
    }
  },
  redirectRoute('/garments/:id', (to) => process.env.VUE_APP_EPOS_API_BASE
      + '/index.php?page=garment&mode=editor&garment=' + to.params.id, {
    name: 'ViewGarment',
  }),
  redirectRoute('/search/:id', (to) => process.env.VUE_APP_EPOS_API_BASE
      + '/index.php?page=garment&mode=editor&search=' + to.params.id),
  {
    path: '/test',
    component: TestPage,
    beforeEnter (to, from, next) {
      console.log('garmenttype auth: ' + store.getters.token);
      if (store.getters.token) {
        next()
      } else {
        next('/signin')
      }
    }
  },
  {
    path: '/garmenttypes/create',
    component: GarmentTypeCreatePage,
    beforeEnter (to, from, next) {
      console.log('garmenttype auth: ' + store.getters.token);
      if (store.getters.token) {
        next()
      } else {
        next('/signin')
      }
    }
  },
  {
    path: '/garmenttype/:id',
    component: GarmentTypePage,
    name: "GarmentTypeEdit",
    beforeEnter (to, from, next) {
      if (store.getters.token) {
        next()
      } else {
        next('/signin')
      }
    }
  },
  {
    path: '/vouchers',
    component: VouchersPage,
    beforeEnter (to, from, next) {
      if (store.getters.token) {
        next()
      } else {
        next('/signin')
      }
    }
  },
  {
    path: '/mpos/slot-locator',
    component: SlotLocatorPage,
    beforeEnter (to, from, next) {
      if (store.getters.token) {
        next()
      } else {
        next('/signin')
      }
    }
  },
 {
      path: '/mpos/q-pup',
      component: QpupPage,
      beforeEnter (to, from, next) {
        if (store.getters.token) {
          next()
        } else {
          next('/signin')
        }
      }
    },
  {
    path: '/report/locker-usage',
    component: LockerUsagePage,
    beforeEnter (to, from, next) {
      if (store.getters.token) {
        next()
      } else {
        next('/signin')
      }
    }
  },
  // ********************* MOBILE MENU ROUTES ***********************
  redirectRoute('/mpos/logistics', () => process.env.VUE_APP_LEGACY_MPOS_URL + '/index.php?page=logistics&mode=manifests'),
  redirectRoute('/mpos/production', () => process.env.VUE_APP_LEGACY_MPOS_URL + '/index.php?page=production&mode=scanner'),
  redirectRoute('/mpos/process', () => process.env.VUE_APP_LEGACY_MPOS_URL + '/index.php?page=process&mode=home'),
  redirectRoute('/mpos/quality-control', () => process.env.VUE_APP_LEGACY_MPOS_URL + '/index.php?page=qc&mode=home'),
  redirectRoute('/mpos/dispatch', () => process.env.VUE_APP_LEGACY_MPOS_URL + '/index.php?page=dispatch&mode=home'),
  redirectRoute('/mpos/garment-info', () => process.env.VUE_APP_LEGACY_MPOS_URL + '/index.php?page=process&mode=garment'),
  redirectRoute('/mpos/repair', () => process.env.VUE_APP_LEGACY_MPOS_URL + '/index.php?page=repair&mode=home'),
  // ********************* RFID ROUTES ***********************
  {
    path: '/rfid/dashboard',
    component: RfidDashboardPage,
    beforeEnter (to, from, next) {
      if (store.getters.token) {
        next()
      } else {
        next('/signin')
      }
    }
  },
  {
    path: '/rfid/associate-tag',
    component: RfidAssociateTagPage,
    beforeEnter (to, from, next) {
      if (store.getters.token) {
        next()
      } else {
        next('/signin')
      }
    }
  },
  {
    path: '/rfid/association-logs',
    component: RfidAssociationListLogsPage,
    beforeEnter (to, from, next) {
      if (store.getters.token) {
        next()
      } else {
        next('/signin')
      }
    }
  },
  {
    path: '/rfid/association-logs/:id',
    component: RfidAssociationLogsPage,
    name: "ViewBatch",
    beforeEnter (to, from, next) {
      if (store.getters.token) {
        next()
      } else {
        next('/signin')
      }
    }
  },
  {
    path: '/rfid/processing-selection',
    component: RfidProcessingSelectionPage,
    beforeEnter (to, from, next) {
      if (store.getters.token) {
        next()
      } else {
        next('/signin')
      }
    }
  },
  {
    path: '/rfid/processing-selection/:id',
    component: RfidProcessingOrderPage,
    name: "ViewOrderRfid",
    beforeEnter (to, from, next) {
      if (store.getters.token) {
        next()
      } else {
        next('/signin')
      }
    }
  },
  {
    path: '/rfid/processing-logs',
    component: RfidProcessingListLogsPage,
    beforeEnter (to, from, next) {
      if (store.getters.token) {
        next()
      } else {
        next('/signin')
      }
    }
  },
  {
    path: '/rfid/processing-logs/:id',
    component: RfidProcessingLogsPage,
    name: "ViewProcessingLog",
    beforeEnter (to, from, next) {
      if (store.getters.token) {
        next()
      } else {
        next('/signin')
      }
    }
  },
  {
    path: '/rfid/rogue-gallery',
    component: RfidRogueListLogsPage,
    beforeEnter (to, from, next) {
      if (store.getters.token) {
        next()
      } else {
        next('/signin')
      }
    }
  },
  {
    path: '/rfid/rogue-gallery/:id',
    component: RfidRogueLogsPage,
    name: "ViewRogueTransaction",
    beforeEnter (to, from, next) {
      if (store.getters.token) {
        next()
      } else {
        next('/signin')
      }
    }
  },
  {
    path: '/rfid/folding-ticket',
    component: RfidFoldingTicketPage,
    beforeEnter (to, from, next) {
      if (store.getters.token) {
        next()
      } else {
        next('/signin')
      }
    }
  },
  //r.Path("/api/servicetickets/{serviceTicketID:ST[0-9]{9}}/{checkCode}").
  {
    path: '/rfid/folding-ticket/:serviceTicketID/:checkCode',
    component: RfidFoldingTicketOrderPage,
    beforeEnter (to, from, next) {
      if (store.getters.token) {
        next()
      } else {
        next('/signin')
      }
    }
  },
  {
    path: '/rfid/pieceup',
    component: RfidPieceupPage,
    beforeEnter (to, from, next) {
      if (store.getters.token) {
        next()
      } else {
        next('/signin')
      }
    }
  },
  {
    path: '/rfid/pieceup-logs',
    component: RfidPieceupLogsPage,
    beforeEnter (to, from, next) {
      if (store.getters.token) {
        next()
      } else {
        next('/signin')
      }
    }
  },
    
]
const router = createRouter({
  history: createWebHistory(),
  //history: createWebHashHistory(),
  routes,
});

router.afterEach((to) => {
  persistLastContextPath(to.path)
})

export default router;
